import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-tank-quick-filter',
  templateUrl: './global-tank-quick-filter.component.html',
  styleUrls: ['./global-tank-quick-filter.component.css']
})
export class GlobalTankQuickFilterComponent implements OnInit {

  @Input() filterName: string;
  @Input() filterIcon: string;
  @Input() value: string | number;
  @Input() color: string;
  @Input() activeFilter: boolean = false;

  constructor() { }

  ngOnInit() {

  }

}
